import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        "flex w-full resize-none bg-transparent text-[15px] leading-snug",
        "border-0 outline-none focus:ring-0 focus-visible:ring-0",
        "placeholder:text-text-muted",
        "min-h-[42px] max-h-[150px] px-2 py-[10px]",
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
